const USER_ORGANIZATION_STATUS = {
  All: "All",
  Approved: "Approved",
  Blocked: "Blocked",
  Pending: "Pending",
  "Under Process": "Under Process",
};
export default USER_ORGANIZATION_STATUS;
